import http from "./http";


export default {
    queryPairMarketDelegationDistinguish(data){
        return http.post({
            url: '/admin/market/delegation/user/distinguish',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    getLocalTime(unixTimeStamp) {
        if (unixTimeStamp){
            unixTimeStamp = new Date(unixTimeStamp)
            let Y = unixTimeStamp.getFullYear() + '-';
            let M = (unixTimeStamp.getMonth()+1 < 10 ? '0'+(unixTimeStamp.getMonth()+1) : unixTimeStamp.getMonth()+1) + '-';
            let D = (unixTimeStamp.getDate() < 10 ? '0'+unixTimeStamp.getDate() : unixTimeStamp.getDate()) + ' ';
            let h = (unixTimeStamp.getHours() < 10 ? '0'+unixTimeStamp.getHours() : unixTimeStamp.getHours()) + ':';
            let m = (unixTimeStamp.getMinutes() < 10 ? '0'+unixTimeStamp.getMinutes() : unixTimeStamp.getMinutes()) + ':';
            let s = (unixTimeStamp.getSeconds() < 10 ? '0'+unixTimeStamp.getSeconds() : unixTimeStamp.getSeconds());
            return Y+M+D+h+m+s;
        }
    },
}